import { FlowObjectDefinition } from "./flow-object.model";
import { Guid } from "guid-typescript";
import { Enums } from '../shared/enums';
import { ConfigSchemaFlowDefinition } from "./config-schema.model";

export class FlowDefinition {
    id?: string = Guid.create().toString();
    name?: string = Enums.Messages.MyNewFlow;
    publicName?: string;
    publishedName?: string;
    description?: string;
    publishedDescription?: string;
    configSchema?: string = JSON.stringify(new ConfigSchemaFlowDefinition());
    version?: number = 1;
    isActive?: boolean = true;
    isPublished? = false;
    isPinned? = false;
    isUnlistedModeActive? = false;
    ownerId?: string;
    ownerInfo?: string = null;
    unitId?: string;
    unitInfo?: string = null;
    publishedUnitId?: string = null;
    publishedUnitInfo?: string = null;
    organizationId?: string;
    organizationInfo?: string = null;
    publishedOrganizationId?: string = null;
    publishedOrganizationInfo?: string = null;
    patriarchId?: string;
    patriarchInfo?: string = null;
    publishedPatriarchId?: string = null;
    publishedPatriarchInfo?: string = null;
    targetId?: number = FlowTarget.Citizen;
    publishedTargetId?: number = null;
    contextId?: string = null;
    catalogServiceId?: string = null;
    flowInboxDirectoryId?: string = null;
    contextIndex?: number = null;
    createDate?: Date;
    updateDate?: Date;
    publishDate?: Date;
    versionDate?: Date;
    activateDate?: Date;
    deactivateDate?: Date;
    pinDate?: Date;
    flowObjectDefinitions?: FlowObjectDefinition[] = [];
    flowTargetWhitelist?: FlowTargetWhitelist[] = [];

    public constructor(init?: Partial<FlowDefinition>) {
        Object.assign(this, init);
    }
}

export enum FlowTarget {
    Unit = 0,
    Organization = 1,
    Patriarch = 2,
    Citizen = 3,
    Whitelist = 4
}

export const FlowTargetLabel = new Map<number, string>([
    [FlowTarget.Unit, 'Setor'],
    [FlowTarget.Organization, 'Órgão'],
    [FlowTarget.Patriarch, 'Patriarca'],
    [FlowTarget.Citizen, 'Cidadão'],
    [FlowTarget.Whitelist, 'Lista de Permissão'],
]);

export const FlowTargetDescription = new Map<number, string>([
    [FlowTarget.Unit, 'Apenas servidores com algum papel lotado no Setor relacionado à Caixa de Fluxos onde este Fluxo se encontra'],
    [FlowTarget.Organization, 'Apenas servidores com algum papel lotado no Órgão relacionado à Caixa de Fluxos onde este Fluxo se encontra'],
    [FlowTarget.Patriarch, 'Apenas servidores com algum papel lotado no Patriarca relacionado à Caixa de Fluxos onde este Fluxo se encontra'],
    [FlowTarget.Citizen, 'Qualquer cidadão'],
    [FlowTarget.Whitelist, 'Apenas servidores com algum papel lotado nos Setores e Organizações relacionados']
]);

export class FlowDefinitionContext {
    id?: string = Guid.createEmpty().toString();
    catalogServiceId?: string = null;
    name?: string = null;
    flowDefinitions?: FlowDefinition[] = [];

    public constructor(init?: Partial<FlowDefinitionContext>) {
        Object.assign(this, init);
    }
}

export class FlowTargetWhitelist {
    id?: number;
    flowDefinitionId?: string;
    patriarchId?: string;
    organizationId?: string;
    unitId?: string;

    public constructor(init?: Partial<FlowTargetWhitelist>) {
        Object.assign(this, init);
    }
}
